import React, { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { colors } from '@mui/material';
import { Page, Header } from 'components';
import MopRanReportUpload from './MopRanReport/MopRanReportUpload';
import MopRanTemplate from './MopRanTemplate/MopRanTemplate';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3)
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const MopRanReport = () => {
	const classes = useStyles();

	return (
		<Page className={classes.root} title="MOP RAN Report">
			<Header module="MOP RAN Report" view="MOP RAN Report" />
			<MopRanTemplate />
			<MopRanReportUpload className={classes.content} />
		</Page>
	);
};

export default MopRanReport;
